import Navbar from "../Homepage/Navbar";
import LostFound from "./LostFound";

export default function LostFoundPage() {
  return (
    <>
      <div className="container-2">
        <LostFound />
      </div>
    </>
  );
}
